function buildLocalDate(year, month, day) {
  return new Date(year, month - 1, day);
}

function getDateOnlyMatch(value) {
  if (typeof value !== "string") return null;
  return value.trim().match(/^(\d{4})-(\d{2})-(\d{2})(?!\d)/);
}

export function parseDateLike(value) {
  if (!value) return null;

  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null;
    return new Date(value.getTime());
  }

  const dateOnlyMatch = getDateOnlyMatch(value);
  if (dateOnlyMatch) {
    const [, year, month, day] = dateOnlyMatch;
    return buildLocalDate(Number(year), Number(month), Number(day));
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;
  return parsed;
}

export function toDateInputValue(value) {
  const date = parseDateLike(value);
  if (!date) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function formatDateLabel(value, fallback = "-") {
  if (!value) return fallback;

  const date = parseDateLike(value);
  if (!date) return typeof value === "string" ? value : fallback;
  return date.toLocaleDateString("pt-BR");
}

export function startOfDay(value) {
  const date = parseDateLike(value);
  if (!date) return null;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function endOfDay(value) {
  const date = startOfDay(value);
  if (!date) return null;
  date.setHours(23, 59, 59, 999);
  return date;
}

export function addCalendarDays(value, days) {
  const date = startOfDay(value);
  if (!date) return "";
  date.setDate(date.getDate() + days);
  return toDateInputValue(date);
}
